export default {
  PostComment: 'Comentários',
  MentionComment: 'Comentários em menções',
  ExternalComment: 'Comentários externos',
  ReviewComment: 'Comentários em avaliações',
  VisitorComment: 'Comentário em publicação de visitante',
  Mention: 'Menções',
  Review: 'Avaliações',
  Post: 'Publicações proprietárias',
  VisitorPost: 'Publicações de visitante',
  Inbox: 'Inbox',
  Story: 'Story',
  Reels: 'Reels',
};
